import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  note?: string;
  noteTone?: "dark" | "light";
  className?: string;
};
export function CtaButton({
  label,
  id,
  note,
  noteTone = "dark",
  className = ""
}: CtaButtonProps) {
  return <div id={id} className={`mx-auto w-full max-w-xl text-center ${className}`} data-id="element-29" data-mp="cj7uas0hhrig">
      <a href={CHECKOUT_URL} className="animate-cta-pulse group flex min-h-[64px] w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-4 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-lg" data-id="element-30" data-mp="qj94iy2n2bal">
        <span data-id="element-31" data-mp="198p4nkaew1qh">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="159zue0ko70b2" />
      </a>
      {note && <p className={`mt-3 text-sm leading-relaxed ${noteTone === "light" ? "text-white/75" : "text-ink-muted"}`} data-id="element-33" data-mp="35zinyinaqcs7">{note}</p>}
    </div>;
}